import React, { Component, Suspense } from 'react';
import { Switch, Route } from 'react-router';
import { Spinner } from 'reactstrap';
import { Home } from './components/Home';
import { AdminLayout } from './components/admin/AdminLayout';
import AuthService from './AuthService'; //Auth0

// Admin portal lives at admin.<host> (e.g. admin.test-diptekpulse.com), served by the
// SAME container/SPA — traefik routes admin.* and the bare host to the same webapp
// service. Detect at boot and render either AdminLayout or Home as the root component.
// Pattern mirrors the per-app subdomain convention already used by gps.diptekpulse.com.
const IS_ADMIN_HOST = typeof window !== 'undefined' &&
    typeof window.location !== 'undefined' &&
    typeof window.location.hostname === 'string' &&
    window.location.hostname.toLowerCase().startsWith('admin.');

// Phase 24 Plan 01 — Code-split the /stats and /stats/compare routes. Plotly
// is ~3 MB; keeping it out of the main bundle saves first-paint on Home.js
// and /startSession. RESEARCH Pattern 6 — both routes are React.lazy with a
// shared reactstrap <Spinner> Suspense fallback.
const StatsPage        = React.lazy(() => import('./components/stats/StatsPage'));
const StatsCompareView = React.lazy(() => import('./components/stats/StatsCompareView'));

export default class App extends Component {
    static displayName = App.name;

    constructor() {
        super();
        this.authService = new AuthService(); //Auth0
    }

    renderHome() {
        let resultComponent = <Home auth={this.authService} />;

        if (!this.authService.isAuthenticated()) {
            this.authService.login();
            resultComponent = <div><p>Redirecting to the authentication service...</p></div>
        }

        return resultComponent;
    }

    startSession(history) {
        this.authService.handleAuthentication(history);
        return <div><p>Starting session...</p></div>;
    }

    render() {
        if (IS_ADMIN_HOST) {
            return (
                <Switch>
                    <Route path="/startSession" render={({ history }) => this.startSession(history)} />
                    <Route path="/" render={({ match }) => <AdminLayout auth={this.authService} match={match} />} />
                </Switch>
            );
        }

        return (
          <Switch>
                <Route exact path="/" render={() => this.renderHome()} />
                <Route path="/startSession" render={({ history }) => this.startSession(history)} />
                {/* Phase 24 Plan 01 — /stats/compare MUST precede /stats; the Switch
                    matches in order and /stats would otherwise prefix-match /stats/compare
                    (same precedent as AdminLayout.js:74-83 with /sites/create vs
                    /sites/:locationId(\d+)/config). */}
                <Route path="/stats/compare" render={() => (
                    <Suspense fallback={<div className="container mt-5"><Spinner /></div>}>
                        <StatsCompareView auth={this.authService} />
                    </Suspense>
                )} />
                <Route path="/stats" render={() => (
                    <Suspense fallback={<div className="container mt-5"><Spinner /></div>}>
                        <StatsPage auth={this.authService} />
                    </Suspense>
                )} />
          </Switch>
        );
    }
}
